import { createStyles, makeStyles } from '@material-ui/styles';
const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      fontWeight: 500
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
